import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { api } from "@/lib/api";

const price = (p, annual) => {
  if (p.contact_sales || p.monthly_price == null) return ["Custom", ""];
  return annual ? [`£${Math.round(p.annual_price / 12)}`, "/mo billed annually"] : [`£${p.monthly_price}`, "/month"];
};

export const PricingCards = () => {
  const [plans, setPlans] = useState([]);
  const [annual, setAnnual] = useState(false);
  useEffect(() => {
    api.get("/public/plans").then((r) => setPlans(r.data));
  }, []);
  return (
    <div>
      <div className="mb-10 flex justify-center">
        <div className="inline-flex rounded-full border border-white/10 bg-white/5 p-1 text-sm">
          {[["Monthly", false], ["Annual", true]].map(([l, v]) => (
            <button key={l} data-testid={`pricing-toggle-${l.toLowerCase()}`} onClick={() => setAnnual(v)} className={`rounded-full px-5 py-1.5 transition-colors ${annual === v ? "bg-health font-semibold text-navy" : "text-slate-300"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
        {plans.map((p) => {
          const [amt, per] = price(p, annual);
          return (
            <div key={p.slug} data-testid={`plan-card-${p.slug}`} className={`card-lift relative flex flex-col rounded-3xl border p-7 ${p.popular ? "border-health/60 bg-health/[0.06]" : "border-white/10 bg-white/[0.02]"}`}>
              {p.popular && <span className="absolute -top-3 left-7 rounded-full bg-health px-3 py-0.5 text-xs font-semibold text-navy">Most popular</span>}
              <h3 className="text-xl font-semibold text-white">{p.name}</h3>
              <p className="mt-1 min-h-[40px] text-sm text-slate-400">{p.description}</p>
              <p className="mt-6 font-display text-4xl font-bold text-white" data-testid={`plan-price-${p.slug}`}>{amt}<span className="ml-1 text-sm font-normal text-slate-400">{per}</span></p>
              {p.monthly_price != null && <p className="mt-1 text-xs text-slate-500">Prices exclude VAT</p>}
              <ul className="mt-6 flex-1 space-y-2.5 text-sm text-slate-300">
                {(p.highlights || []).map((h) => <li key={h} className="flex gap-2"><Check className="mt-0.5 h-4 w-4 shrink-0 text-health" />{h}</li>)}
              </ul>
              <Link to={p.contact_sales ? "/contact" : `/register?plan=${p.slug}`} data-testid={`plan-cta-${p.slug}`} className={`mt-8 rounded-full py-2.5 text-center text-sm font-semibold transition-transform hover:-translate-y-0.5 ${p.popular ? "bg-health text-navy" : "border border-white/15 text-white hover:bg-white/5"}`}>
                {p.contact_sales ? "Talk to us" : p.trial_days ? `Start ${p.trial_days}-day trial` : "Choose plan"}
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default function Pricing() {
  useEffect(() => {
    document.title = "Pricing | Saflr";
  }, []);
  return (
    <main className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
      <p className="eyebrow text-center">Pricing</p>
      <h1 className="mx-auto mt-3 max-w-3xl text-center text-4xl font-bold text-white sm:text-5xl lg:text-6xl">Plans that grow with your HSE function</h1>
      <p className="mx-auto mt-5 max-w-xl text-center text-slate-400">Every plan includes AI document generation, controlled document management and professional exports. Credits are only used when generation succeeds.</p>
      <div className="mt-14"><PricingCards /></div>
    </main>
  );
}
